import React from 'react';
import './Home.module.scss';
import { HomeProvider } from './home-context';
import Welcome from '../../components/welcome/Welcome';
import News from '../../components/news/News';

const Home = () => {
  return (
    <HomeProvider>
      <Welcome />
      <News />
    </HomeProvider>
  );
};

export default Home;
